import { BehindFlag, ConnectionAlertMessage } from '@/app/components'
import ErrorBoundary, {
  LocationTag,
} from '@/authenticated/components/ErrorBoundary'
import { useUrlSearchParam } from '@/hooks'
import { Thermostat } from '@/types'
import Tabs from '@/components/Tabs'
import { useHistory } from 'react-router-dom'
import useThermostatDeviceSectionViewModel from './useThermostatDeviceSectionViewModel'
import ThermostatProgramsTab from './components/ThermostatProgramsTab'
import ThermostatSettingsTab from './components/ThermostatSettingsTab'

export type Props = {
  thermostatId: Thermostat['id']
}

function ThermostatDeviceSectionComponent(props: Props) {
  const viewModel = useThermostatDeviceSectionViewModel(props)

  const initialTab = useUrlSearchParam('tab')
  const tabs = ['Programs', 'Settings']
  const history = useHistory()
  const handleTabChange = (index: number) => {
    const tab = tabs[index]
    history.replace({ search: `?tab=${tab.toLowerCase()}` })
  }
  return (
    <div className="flex flex-col items-center space-y-6">
      <ConnectionAlertMessage connectionRequirements={['meter', 'utility']} />
      <Tabs.Tabs
        initialTabIndex={+(initialTab === 'settings')}
        tabKey="schedule-vehicle-tabs"
        labels={tabs}
        tabBarAttributes={{ className: 'max-w-none' }}
        onTabChange={handleTabChange}
      />
      <Tabs.Content tabKey="schedule-vehicle-tabs">
        <ThermostatProgramsTab {...viewModel} />
        <ThermostatSettingsTab {...viewModel} />
      </Tabs.Content>
    </div>
  )
}

export default function ThermostatDeviceSection(props: Props) {
  return (
    <ErrorBoundary
      location={LocationTag.ThermostatSchedule}
      functionalityDescription="Thermostat Schedule Settings"
      severity="critical"
    >
      <BehindFlag flag="thermostat_schedule_settings" experimental>
        <ThermostatDeviceSectionComponent {...props} />
      </BehindFlag>
    </ErrorBoundary>
  )
}
